module.exports = __webpack_public_path__ + "4f593e2ee01a6839851cfdef92697da5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_folders_2x.png
// module id = 93
// module chunks = 0 1 2 3 4